/* eslint-disable camelcase */
import axios from '../utils/axios';
import { apiurl } from '../config/apiUrl';

export const returnPolicies = () => {
  const parsedString = JSON.parse(localStorage.getItem('user_permissions'));
  return parsedString;
};

export default async function ProfilePolicies() {
const config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('access_token')}` || null
  }
};
const policies = await axios.get(apiurl?.getPolicies, config);

  const policyArray = policies?.data?.policies;
  const getAllPolicies = (
    viewPolicy,
    editPolicy,
    pdfDownloadPolicy,
    excelDownload,
    commitedDownload
  ) => {
    let policyObject = {
      canAccess: false,
      canEdit: false,
      canPdfDownload: false,
      canExcelDownload: false,
      canCommittedDownload: false
    };
    if (
      (policyArray && policyArray === null)
      || (policyArray && policyArray === undefined)
    ) {
      return policyObject;
    }
    const view_policy = viewPolicy
      ? policyArray && policyArray.find((e) => e === viewPolicy)
      : null;
    const edit_policy = editPolicy
      ? policyArray && policyArray.find((e) => e === editPolicy)
      : null;
    const pdf_Download_policy = pdfDownloadPolicy
      ? policyArray && policyArray.find((e) => e === pdfDownloadPolicy)
      : null;
    const excel_download_policy = excelDownload
      ? policyArray
      && policyArray.find((e) => e === excelDownload)
      : null;
    const commited_download_policy = commitedDownload
      ? policyArray && policyArray.find((e) => e === commitedDownload)
      : null;

    const canEdit = !!(edit_policy && edit_policy);
    const canAccess = !!(
      canEdit
      || (view_policy && view_policy)
    );
    const canPdfDownload = !!(pdf_Download_policy && pdf_Download_policy);
    const canExcelDownload = !!(excel_download_policy && excel_download_policy);
    const canCommittedDownload = !!(commited_download_policy && commited_download_policy);

    policyObject = {
      canAccess,
      canEdit,
      canPdfDownload,
      canExcelDownload,
      canCommittedDownload
    };
    return policyObject;
  };
  const dropDownListAccessCheck = () => {
    if (!Array.isArray(policyArray) || policyArray.length === 0) {
      return false;
    }
    const hasRequiredPolicy = policyArray?.includes('kaas_master_view_access')
    || policyArray?.includes('vendor_kaas_purchase_order_view_access');

    return hasRequiredPolicy;
  };
  const dropDownAccess = dropDownListAccessCheck();
  const ppePolicies = getAllPolicies(
    'kaas_ppe_view_access',
    'kaas_ppe_edit_access'
  );
const expensePolicies = getAllPolicies(
    'kaas_expense_line_item_view_access',
    'kaas_expense_line_item_edit_access'
  );
  const vendorPolicies = getAllPolicies(
    'kaas_vendor_view_access',
    'kaas_vendor_edit_access'
  );
  const poPolicies = getAllPolicies(
    'kaas_purchase_order_view_access',
    'kaas_purchase_order_edit_access',
    'kaas_purchase_order_pdf_download',
    'kaas_purchase_order_excel_download',
    'kaas_purchase_order_committedcost_download'
  );
  const VesselpoPolicies = getAllPolicies(
    'kaas_vessel_purchase_order_view_access',
    'kaas_vessel_purchase_order_edit_access'
  );
   const agencyPoPolicies = getAllPolicies(
    'kaas_agency_purchase_order_view_access',
    'kaas_agency_purchase_order_edit_access'
  );
  const vendorDashboardPolicies = getAllPolicies(
    'vendor_kaas_purchase_order_view_access',
    'vendor_kaas_purchase_order_edit_access'
  );
  const logPolicies = getAllPolicies(
    'kaas_log_view_access',
    ''
  );
  // Single admin policy for Vessel Cost Centre / Fixed Budget master pages
  // Pass same policy for view + edit so Upload / Download / Delete are enabled
  const sapPoAdminPolicies = getAllPolicies(
    'kaas_sap_po_admin_policy',
    'kaas_sap_po_admin_policy'
  );

  const profilePolicies = {
    ppePolicies,
    expensePolicies,
    vendorPolicies,
    poPolicies,
    VesselpoPolicies,
    agencyPoPolicies,
    logPolicies,
    vendorDashboardPolicies,
    sapPoAdminPolicies,
    dropDownAccess
  };

  return profilePolicies;
}
